<ng-container *ngIf="vm$ | async as vm">
	<div class="flex h-full">
		<div class="min-w-64 flex flex-col">
			<div class="flex-1 overflow-y-auto">
				<div class="flex flex-col gap-4 p-4">
					<div class="flex flex-col">
						<div class="mb-2">
							<p
								class="p-xs font-medium text-gray-500 tracking-widest uppercase"
							>
								Categories
							</p>
						</div>
						<ng-container *ngFor="let category of vm.categoriesMenu?.items">
							<button
								[attr.data-intercom-target]="category.dataIntercomTarget"
								[id]="category.key"
								[ariaSelected]="isSelected('category', category.key)"
								[aria-controls]="
									category.children && category.children.length > 0
										? category.key + '-children'
										: null
								"
								[ariaExpanded]="
									category.children && category.children.length > 0
										? vm.expandedCategories[category.key]
										: null
								"
								(click)="
									toggleCategory(
										category.key,
										null,
										category.children && category.children.length > 0
									)
								"
								class="group/parent-button flex justify-between items-center px-2 py-1.5 mb-1 rounded-md w-full duration-300 hover:bg-gray-100 aria-selected:bg-[#ECFAF7] aria-selected:hover:bg-[#ECFAF7]"
								[testHook]="testHooks.Category"
							>
								<p
									class="p-sm text-gray-500 group-aria-selected/parent-button:text-gray-700"
								>
									{{ category.title.label }}
									@if (category.isNew) {
										<span class="text-tealGreen-600 p-xs">New!</span>
									}
								</p>
								<i-tabler
									*ngIf="category.children && category.children.length > 0"
									[class.rotate-180]="vm.expandedCategories[category.key]"
									name="chevron-down"
									class="size-4 text-gray-500 transition-transform duration-300"
								/>
							</button>

							<!-- Child items -->
							<div
								*ngIf="category.children && category.children.length > 0"
								[id]="category.key + '-children'"
								class="duration-300 grid-rows-[0fr] grid h-full"
								[ngClass]="{
									'grid-rows-[1fr]': vm.expandedCategories[category.key],
								}"
							>
								<div class="overflow-hidden flex flex-col gap-1 ml-4">
									<button
										*ngFor="let child of category.children"
										[tabindex]="vm.expandedCategories[category.key] ? 0 : -1"
										[ariaSelected]="
											isSelected('category', category.key, child.key)
										"
										(click)="toggleCategory(category.key, child.key)"
										class="group/child-button flex justify-between items-center px-2 py-1.5 rounded-md hover:bg-gray-100 duration-300 aria-selected:bg-[#ECFAF7] w-full"
										[testHook]="testHooks.ToggleCategoryButton"
									>
										<p
											class="p-sm max-w-44 truncate text-gray-500 group-aria-selected/child-button:text-gray-700"
										>
											{{ child.title.label }}
										</p>
									</button>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
		<div
			class="p-4 gap-4 flex-1 flex flex-col h-full overflow-hidden bg-gray-50 border-l border-gray-200"
		>
			<div>
				<div class="relative">
					<i-tabler
						name="search"
						class="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-gray-400"
					></i-tabler>
					<input
						#searchInput
						placeholder="Search documents"
						class="p-sm pl-8 pr-12 py-2 rounded-md border border-gray-200 w-full focus:outline-green placeholder:text-gray-500"
						[formControl]="searchFormControl"
						[testHook]="testHooks.Search"
					/>
					<ui-button
						*ngIf="searchFormControl.value"
						(click)="clearSearch(searchInput)"
						preset="ICON_DEFAULT"
						size="xs"
						icon="x"
						class="absolute right-2 top-1/2 -translate-y-1/2"
						[testHook]="testHooks.Button"
					>
					</ui-button>
				</div>
			</div>

			<ng-container *ngIf="selectedCategoryHasNoChildren_()">
				@switch (selectedCategoryItem_()?.parentKey) {
					@case (DOCUMENT_CATEGORY.COMPLIANCE_REQUEST) {
						<ng-container
							*ngTemplateOutlet="
								emptyContextState;
								context: {
									$implicit: {
										title: 'Add a Jurisdiction to view available documents.',
										buttonLabel: 'Add Jurisdiction',
										onClick: onAddJurisdiction.bind(this),
									},
								}
							"
						/>
					}
					@case (DOCUMENT_CATEGORY.MORTGAGE) {
						<ng-container
							*ngTemplateOutlet="
								emptyContextState;
								context: {
									$implicit: {
										title: 'Add a Mortgage to view available documents.',
										buttonLabel: 'Add Mortgage',
										onClick: onAddMortgage.bind(this),
									},
								}
							"
						/>
					}
					@case (DOCUMENT_CATEGORY.CLIENT) {
						<ng-container
							*ngTemplateOutlet="
								emptyContextState;
								context: {
									$implicit: {
										title: 'Add a Client to view available documents.',
										buttonLabel: 'Add Client',
										onClick: onAddClient.bind(this),
									},
								}
							"
						/>
					}
					@case (DOCUMENT_CATEGORY.ENCUMBRANCE) {
						<ng-container
							*ngTemplateOutlet="
								emptyContextState;
								context: {
									$implicit: {
										title: 'Add an Encumbrance to view available documents.',
										buttonLabel: 'Add Encumbrance',
										onClick: onAddEncumbrance.bind(this),
									},
								}
							"
						/>
					}
					@case (DOCUMENT_CATEGORY.DEBT) {
						<ng-container
							*ngTemplateOutlet="
								emptyContextState;
								context: {
									$implicit: {
										title: 'Add a Bill or Debt to view available documents.',
										buttonLabel: 'Add Bill or Debt',
										onClick: onAddBillOrDebt.bind(this),
									},
								}
							"
						/>
					}
				}
			</ng-container>

			<div class="flex-1 w-full overflow-hidden flex flex-col">
				<div class="flex justify-between items-center pb-4">
					<div class="flex items-center gap-x-2">
						<span class="p-sm text-gray-700"> Documents </span>
						<ui-badge
							size="sm"
							[label]="documentCount_()"
							[testHook]="testHooks.Badge"
						>
						</ui-badge>
					</div>
					<div class="flex items-center gap-x-4">
						<div
							class="flex items-center gap-x-2"
							data-intercom-target="most-used-documents-sort-by"
							*ngIf="
								selectedCategoryItem_()?.parentKey ===
								DOCUMENT_CATEGORY.MOST_USED
							"
						>
							<span class="p-xs text-gray-500">Sort by</span>
							<button
								(click)="toggleSortByUsageWeight()"
								class="group/sortBy relative flex items-center bg-gray-100 rounded-lg px-0.5"
								type="button"
								role="switch"
								[attr.aria-checked]="sortByUsageWeight_()"
								[testHook]="testHooks.ToggleSortByUsageWeightDiv"
							>
								<div
									class="absolute transform top-0.5 bottom-0.5 w-10 bg-white shadow-sm rounded-md transition-transform duration-300 ease-in-out translate-x-10 group-aria-checked/sortBy:translate-x-0"
								></div>

								<div
									class="relative flex items-center justify-center w-10 h-6 z-10 transition-colors duration-200 text-gray-500 group-aria-checked/sortBy:text-tealGreen-600"
									title="Sort by usage frequency"
								>
									<i-tabler name="trending-up" class="size-4" />
								</div>
								<div
									class="relative flex items-center justify-center w-10 h-6 z-10 transition-colors duration-200 text-tealGreen-600 group-aria-checked/sortBy:text-gray-500"
									title="Sort alphabetically"
								>
									<i-tabler name="sort-a-z" class="size-4" />
								</div>
							</button>
						</div>

						<div
							class="flex items-center gap-x-2"
							data-intercom-target="most-used-documents-hide-added"
						>
							<span class="p-xs text-gray-500">Hide Added</span>
							<ui-toggle
								[ngModel]="hideAddedDocuments_()"
								(ngModelChange)="toggleHideAddedDocuments()"
								size="sm"
								[type]="TOGGLE_TYPES.ICON_DEFAULT"
								[testHook]="testHooks.HideAddedDocumentsToggle"
							/>
						</div>

						@if (
							documentCount_() > 0 &&
							selectedCategoryItem_()?.parentKey === DOCUMENT_CATEGORY.UPLOAD
						) {
							<core-button-primary-fill
								size="sm"
								icon="plus"
								iconPosition="left"
								(click)="openUploadModal()"
								[testHook]="testHooks.AddUploadButton"
								[attr.data-intercom-target]="'upload-document-button'"
							>
								Upload
							</core-button-primary-fill>
						}
					</div>
				</div>

				<div
					class="border-gray-200 border rounded-2xl mb-4 overflow-y-auto flex-1 flex flex-col"
				>
					<!-- Documents List -->
					<div
						*ngIf="documentCount_() > 0; else noDocuments"
						class="overflow-y-auto h-full"
					>
						<div class="overflow-hidden h-full top-">
							<div
								class="overflow-y-auto flex flex-col rounded-b-2xl divide-y divide-gray-200 h-full"
							>
								<ui-doc-list-item
									*ngFor="
										let docMeta of getAllDocuments_();
										trackBy: trackByDocId
									"
									[listView]="true"
									[documentMetadata]="docMeta"
									(documentClick)="onAddDocument(docMeta)"
									[includeInDropdown]="[]"
									[hideOpenInWord]="
										docMeta.document?.sourceStorageRef?.endsWith('.docx')
									"
									[hideIncludedInPackages]="true"
									[disabled]="docMeta.isAdded"
									[isAdding]="vm.addingDocIds.includes(docMeta.document.id)"
									[testHook]="testHooks.DocListItem"
								>
									<div
										class="flex gap-x-4 col-span-2 justify-end items-center"
										actions
									>
										<ui-button
											*ngIf="docMeta.isAdded"
											preset="MEDIUM_EMPHASIS"
											size="sm"
											icon="check"
											[disabled]="true"
											[testHook]="testHooks.Button1"
										/>
										<ui-button
											*ngIf="!docMeta.isAdded"
											preset="MEDIUM_EMPHASIS"
											size="sm"
											[loading]="
												docMeta.isLoading ||
												vm.addingDocIds.includes(docMeta.document.id)
											"
											icon="plus"
											(click)="onAddDocument(docMeta)"
											[testHook]="testHooks.Button2"
										/>
									</div>
								</ui-doc-list-item>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>

<ng-template #emptyContextState let-data>
	<div
		class="flex justify-between items-center p-4 pl-5 rounded-2xl bg-amber-50 border border-gray-200"
	>
		<div class="flex items-center gap-x-2">
			<i-tabler name="alert-triangle" class="w-5 h-5 text-orange-500" />
			<h6 class="h6 mb-0">{{ data.title }}</h6>
		</div>
		<ui-button
			*ngIf="data.onClick"
			preset="HIGH_EMPHASIS"
			size="sm"
			icon="plus"
			[label]="data.buttonLabel"
			(click)="data.onClick()"
			[testHook]="testHooks.DataLabelButton"
		/>
	</div>
</ng-template>

<!-- No Documents Template -->
<ng-template #noDocuments>
	<div class="flex flex-col gap-y-4">
		@if (selectedCategoryItem_() && selectedCategoryHasNoChildren_()) {
			@switch (selectedCategoryItem_().parentKey) {
				@case (DOCUMENT_CATEGORY.MOST_USED) {
					<ui-empty
						imageUrl="/assets/images/undraw/undraw_file-searching.svg"
						title="Closer is learning your preferences!"
						description="We create this list based on documents you've used most often in past matters. You will see this list populate as soon as you've closed a matter."
						[testHook]="testHooks.Empty"
					/>
				}
				@case (DOCUMENT_CATEGORY.COMPLIANCE_REQUEST) {
					<ui-empty
						imageUrl="/assets/images/documents/doc-drawer-empty-jurisdictions.svg"
						title="Whoops! No Jurisdiction added yet."
						description="Add a jurisdiction to view available documents."
						[testHook]="testHooks.Empty1"
					/>
				}
				@case (DOCUMENT_CATEGORY.MORTGAGE) {
					<ui-empty
						imageUrl="/assets/images/documents/doc-drawer-empty-mortgages.svg"
						title="Whoops! No Mortgage added yet."
						description="Add a Mortgage to view available documents."
						[testHook]="testHooks.Empty2"
					/>
				}
				@case (DOCUMENT_CATEGORY.CLIENT) {
					<ui-empty
						imageUrl="/assets/images/undraw/undraw_file-searching.svg"
						title="Closer is learning your preferences!"
						description="We create this list based on documents you've used most often in past matters. You will see this list populate as soon as you've closed a matter."
						[testHook]="testHooks.Empty3"
					/>
				}

				@case (DOCUMENT_CATEGORY.ENCUMBRANCE) {
					<ui-empty
						imageUrl="/assets/images/documents/doc-drawer-empty-encumbrances.svg"
						title="Whoops! No Encumbrance added yet."
						description="Add an encumbrance to view available documents."
						[testHook]="testHooks.Empty4"
					/>
				}
				@case (DOCUMENT_CATEGORY.DEBT) {
					<ui-empty
						imageUrl="/assets/images/documents/doc-drawer-empty-debts.svg"
						title="Whoops! No Bill or Debt added yet."
						description="Add a bill or debt to view available documents."
						[testHook]="testHooks.Empty5"
					/>
				}
				@case (DOCUMENT_CATEGORY.UPLOAD) {
					<ui-empty
						imageUrl="/assets/images/undraw/undraw_file-searching.svg"
						title="Whoops! No uploads added yet."
						description="Upload documents to view them here."
						[testHook]="testHooks.Empty6"
					>
						<core-button-primary-fill
							size="md"
							icon="plus"
							iconPosition="left"
							(click)="openUploadModal()"
							[testHook]="testHooks.AddUploadButton"
						>
							Upload
						</core-button-primary-fill>
					</ui-empty>
				}
				@default {
					<ng-container *ngTemplateOutlet="defaultEmptyStates" />
				}
			}
		} @else {
			<ng-container *ngTemplateOutlet="defaultEmptyStates" />
		}
	</div>
</ng-template>

<ng-template #defaultEmptyStates>
	<ui-empty
		imageUrl="/assets/images/undraw/undraw_file-searching.svg"
		title="Whoops! We couldn't find any documents."
		description="Try using a different search term or switching categories to broaden your search."
		[testHook]="testHooks.Empty7"
	>
		<p class="p-sm text-gray-500 mt-6">
			Questions?
			<button
				class="bot-trigger--feedback text-tealGreen-500 hover:text-tealGreen-700 underline"
				[testHook]="testHooks.Button3"
			>
				We're here to help!
			</button>
		</p>
	</ui-empty>
</ng-template>
